<nb-card>
    <nb-card-header>
        {{ "GENERAL.CONFIRMATION" | translate }}
    </nb-card-header>
    <nb-card-body>
        <p>{{ message }}</p>
        <div class="row">
            <div class="col-md-6">
                <button nbButton (click)="nbDialogRef.close(false)" fullWidth>{{ "BUTTONS.BACK" | translate }}</button>
            </div>
            <div class="col-md-6">
                <button nbButton status="danger" (click)="nbDialogRef.close(true)" fullWidth>{{ confirmText }}</button>
            </div>
        </div>
    </nb-card-body>
</nb-card>
